import React, { useEffect } from 'react';
import { Link, Outlet, useLocation } from "react-router-dom";
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import MenuIcon from '@mui/icons-material/Menu'
//import Link from '@mui/material/Link';
import Header from './blog/Header.js'

const drawerWidth = 280;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

const theme = createTheme({
  palette: {
    // mode: 'dark',
    primary: {
      main: '#800000', // Maroon
      light: '#a83248',
      dark: '#560000',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#0066ff', // Blue
      light: '#3399ff',
      dark: '#003399',
      contrastText: '#000000',
    },
  },
  typography: {
    fontFamily: [
      '"Roboto"',
      '"Helvetica"',
      '"Arial"',
      'sans-serif'
    ].join(','),
    h1: {
      fontWeight: 500,
      fontSize: '2.2rem',
      letterSpacing: '-0.01562em',
    },
    // ... other typography styles
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
      },
    },
  },
  components: {
    MuiPaper: {
      defaultProps: {
        elevation: 6,
      },
    },
  },
});

function Copyright() {
  return (<>
    <Typography variant="body2" color="text.secondary" align="center">
      {'© Copyright Blackburn Defense '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
    <Typography variant="body2" color="text.secondary" align="center">
      All Rights Reserved. Unauthorized use and/or duplication of this content, data, or other materials is strictly prohibited without prior express and written permission from the author.
    </Typography>
  </>);
}

function Footer(props) {
  const { description, title } = props;

  return (
    <Box component="footer" sx={{ bgcolor: 'background.paper', mt: 6, pb: 6, alignSelf: 'flex-end' }}>
      <Container maxWidth="lg">
        <Copyright />
      </Container>
    </Box>
  );
}

export default function Layout() {
  const location = useLocation()
  console.log({ location })
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  useEffect(() => {
    // track pageview with gtag / react-ga / react-ga4, for example:
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/*<AppBar position="absolute" open={open}> <Toolbar sx={{ pr: '24px', // keep right padding when drawer closed }} > <IconButton edge="start" color="inherit" aria-label="open drawer" onClick={toggleDrawer} sx={{ marginRight: '36px', ...(open && { display: 'none' }), }} > <MenuIcon /> </IconButton> <Typography component={Link} to="/" variant="h6" color="inherit" noWrap sx={{ flexGrow: 1, textDecoration: 'none' }} > BLACKBURN DEFENSE </Typography> </Toolbar> </AppBar>*/}
      <Container style={{ height: '100vh', display: 'flex', flexDirection: 'column' }} maxWidth={'lg'}>
        <Header title="Blackburn Defense" sections={[
          { url: '/', title: 'Home' },
          { url: '/tools', title: 'Tools' },
          { url: '/tools/data', title: 'My Data', authed: true },
          { url: '/blog', title: 'Blog' },
          { url: '/contact', title: 'Contact Us' }
        ]} />
        {/*<Drawer variant="permanent" open={open}> <Toolbar sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', px: [1], }} > <IconButton onClick={toggleDrawer}> {open ? <ChevronLeftIcon /> : <ChevronRightIcon />} </IconButton> </Toolbar> <Divider /> <List component="nav"> {links.map(link => ( <ListItemButton component={Link} to={link.url}> <ListItemIcon> <link.icon /> </ListItemIcon> <ListItemText primary={link.label} /> </ListItemButton>))} </List> </Drawer>*/}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
          }}
        >
          <Outlet />
        </Box>
        <Footer
          title="Blackburn Defense"
          description="asfi"
        />
      </Container>
    </ThemeProvider>
  );
}
